module.exports = __webpack_public_path__ + "img/ss.67a6fdbc.png";